<template>
    <div class="form-item">
        <div class="form-item__label">租金预算：</div>
        <div class="form-item__body filter-radio">
            <div :class="['form-item__body_input wrapper radio filter-radio__item qudra filter-radio__item_noicon', item.selected ? 'active' : '']"
            v-for="(item, index) in prices" :key="index" @click="select(index)">
                <div class="form-item__body_input_text">{{item.name}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['info'],
        data () {
            return {
                prices: [
                    {name: '1k以下', min: '', max: 1000, selected: false},
                    {name: '1k~2k', min: 1000, max: 2000, selected: false},
                    {name: '2k~4k', min: 2000, max: 4000, selected: false},
                    {name: '4k~6k', min: 4000, max: 6000, selected: false},
                    {name: '6k~8k', min: 6000, max: 8000, selected: false},
                    {name: '8k~10k', min: 8000, max: 10000, selected: false},
                    {name: '10k~15k', min: 10000, max: 15000, selected: false},
                    {name: '15k以上', min: 15000, max: '', selected: false}
                ]
            }
        },
        methods: {
            select (index) {
                for (let i = 0; i<this.prices.length;i++) {
                    this.prices[i].selected = false
                }
                this.prices[index].selected = true
                this.info.cost1 = this.prices[index].min
                this.info.cost2 = this.prices[index].max
            }
        }
    }
</script>

